var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-tabs"},[_c('ul',{staticClass:"about-tabs__container"},_vm._l((_vm.tabs),function(tab,index){return _c('Tab',{key:index,attrs:{"index":index,"tab":tab}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }